import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useRegisterComponent } from '../../../orchestrator';
import { useButtonClickedEvent } from '../../../../utilities/analytics/analytics-web-client';
import Link from '@atlaskit/link';
import messages from '../messages/content';
import { pageId } from '../constants';

/**
 * Renders the "Learn more about two-step verification" external link.
 */
export const TwoStepVerificationMoreInfoLink = () => {
  useRegisterComponent(TwoStepVerificationMoreInfoLink.name);

  const trackMfaLearnMoreLinkClicked = useButtonClickedEvent(pageId, 'MfaPromoteLearnMore');

  return (
    <Link
      id="mfa-promote-learn-more"
      onClick={trackMfaLearnMoreLinkClicked}
      href="https://support.atlassian.com/atlassian-account/docs/manage-two-step-verification-for-your-atlassian-account/"
      target="_blank"
      rel="noopener noreferrer">
      <FormattedMessage {...messages.promoteMfaLearnMore} />
    </Link>
  );
};
